import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetStudentQuestionQuery } from '../../slices/students/questionsApiSlice';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import VideoJS from '../../components/VideoJs';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Subject from '../../components/Subject';

const StudentWatchQuestion = () => {

    const playerRef = useRef(null);

    const { id } = useParams();

    const navigate = useNavigate();

    const { studentInfo } = useSelector((state) => state.authStudent);

    const { data, isLoading, error } = useGetStudentQuestionQuery(id);

    const [isvideo, setIsvideo] = useState(true); 

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
          src: `https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/questions/${data?.mediaId}`,
          type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on('waiting', () => {});
        player.on('dispose', () => {});
    };

    return (
        <div>
            <StudentNavbar />
            <div className="main-content" id="panel">
                <StudentHeader /><br /><br /><br />
                <div className="container-fluid mt--6">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                        <div className="row">
                            <div className="col-xl-10 offset-xl-1">   
                                <div className="card mycard">
                                    <h3 className="tittleColor videoTitle"><span className='tittleColor' style={{textTransform: 'capitalize'}}>
                                        {data?.subjectname}    
                                    </span></h3>
                                    {isvideo  ? 
                                        <VideoJS 
                                            options={videoJsOptions} 
                                            onReady={handlePlayerReady} 
                                            cssRule="card-img-top"
                                        />
                                        :                                       
                                        <div className="card-body "><br /><br /><br />
                                            <h4 className='tittleColor4'>
                                                <span className='tittleColor22'> Video is processing  </span> <br  />
                                                <span className='tittleColor4'> &nbsp; &nbsp; &nbsp; Please check a few minutes later ... </span> <br  />
                                                <img src='../../assets/img/loading.gif' alt='loading' className='loadingVid' /> 
                                                <br /><br /><br /><br />
                                            </h4> 
                                        </div>
                                    }
                                    <div className="card-body ">
                                        <h5 className="h4 card-title mb-0 mycard">
                                        <span className='tittleColor4'>{data?.tittle}</span>
                                        <p className="text-muted ">{data?.description}</p>
                                        </h5>
                                        <LinkContainer to={`/studentasknew`} className='btn btn-default '>
                                            <Button variant="primary  bg-gradient-info"> Ask new Question</Button>
                                        </LinkContainer>
                                        <br /><br /><br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>                  
        </div>
    );
};

export default StudentWatchQuestion;